export const isMetric = (metric1) => (metric2) => {
  return metric1 && metric2 && metric1.field === metric2.field;
};
